import { generateLinearScale } from 'common/components/DataViz/js/generators/generate-linear-scale/generateLinearScale'
import { arcPath } from './js/gaugeMath'
import { formatSeconds } from './js/demoHelpers'

export interface GaugeProps {
  start: boolean;
  end: boolean;
  value: number;
  max: number;
  rows?: number;
  label?: string;
}

const START_ANGLE = -120
const END_ANGLE = 120
const CENTER = 50
const RADIUS = 40

export const Gauge = ({ start, end, value, max, rows, label }: GaugeProps): JSX.Element => {
  const scale = generateLinearScale({ domain: [0, max > 0 ? max : 1], range: [START_ANGLE, END_ANGLE], nice: false })
  const angle = Math.max(START_ANGLE, Math.min(scale?.(value) ?? START_ANGLE, END_ANGLE))

  return (
    <div className={`demo-gauge${end ? ' demo-gauge--end' : ''}`}>
      <svg className='demo-gauge__svg' viewBox='0 0 100 80'>
        <path className='demo-gauge__track' d={arcPath(CENTER, CENTER, RADIUS, START_ANGLE, END_ANGLE)} />
        {start && angle > START_ANGLE && (
          <path className='demo-gauge__value' d={arcPath(CENTER, CENTER, RADIUS, START_ANGLE, angle)} />
        )}
        <text className='demo-gauge__text' x={CENTER} y={CENTER + 4} textAnchor='middle'>
          {start ? formatSeconds(value) : '-'}
        </text>
        {rows !== undefined && (
          <text className='demo-gauge__rows' x={CENTER} y={CENTER + 16} textAnchor='middle'>
            {rows} rows
          </text>
        )}
      </svg>
      {label && <span className='demo-gauge__label demo-skin-muted'>{label}</span>}
    </div>
  )
}
